import { useEmailService } from '@/services/emailService';

export const sendWelcomeEmail = async (email: string, name: string) => {
  const { sendWelcomeEmail: sendEmail } = useEmailService();
  
  try {
    await sendEmail(email, name);
    return true;
  } catch (error) {
    console.error('Failed to send welcome email:', error);
    return false;
  }
};